module.exports = __webpack_public_path__ + "img/logo-square.0a671957.svg";